import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("授权")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消授权")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import Authorization from '@/views/ViewsComponents/financial/Authorization.vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 授权
  'POST/verification/flow_authorize/authorize': authorizeApi,
  // 员工下拉
  'GET/users/list': userListApi,
} = Api

const tabsLoading = ref<boolean>(false)
let userOptions: any = ref([])
onBeforeMount(() => {
  userListApi().then((rep: any) => {
    userOptions.value = rep.map((user: any) => {
      user.name = `${user.alias}(${user.realName})`
      return user
    })
  })
})

// 授权
const authEle = ref()
const isShowAuthorize = ref<boolean>(false)
const authorizeObj: any = reactive({
  orderStart: '', userId: '', flowStart: ''
})

let authSubmitHandle: any = ref()
const showAuthorize = (rows: any, callbackFn: any) => {
  if(rows.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  isShowAuthorize.value = true
  const userIdArr = Array.from(new Set(rows.map((e: any) => e.userId)))
  
  if(userIdArr.length === 1){
    authorizeObj.userId = userIdArr[0]
  }
  new Promise((resolve) => {
    authSubmitHandle.value = resolve
  }).then(() => {
    tabsLoading.value = true
    return authorizeApi({
      customerIds: rows.map((row: any) => row.customerId),
      ...authorizeObj,
      userId: authorizeObj.userId || 0,
      authorize: true
    })
  }).then(() => {
    isShowAuthorize.value = false
    tabsLoading.value = false
    callbackFn()
  }).catch(() => {
    tabsLoading.value = false
    showAuthorize(rows, callbackFn)
  })
  // authorizeObj.userId = row.userId
  /* ElMessageBox.confirm(
    '是否授权?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    tabsLoading.value = true
    return authorizeApi({
      customerIds: row.map(e => e.customerId),
      authorize: true
    })
  }).then(() => {
    ElMessage.success('授权成功')
    tabsLoading.value = false
    callbackFn()
  }).catch(() => {
    tabsLoading.value = false
  }) */
}

// 取消授权
const unauthorizeHandle = (row: any, callbackFn: any) => {
  if(row.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  ElMessageBox.confirm(
    '是否取消授权?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    tabsLoading.value = true
    return authorizeApi({
      customerIds: row.map(e => e.customerId),
      authorize: false
    })
  }).then(() => {
    ElMessage.success('取消授权成功')
    tabsLoading.value = false
    callbackFn()
  }).catch(() => {
    tabsLoading.value = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "未授权" }, {
          default: _withCtx(() => [
            _createVNode(Authorization, { isAuthorize: false }, {
              default: _withCtx(({ seleRows, callbackFn}) => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: ($event: any) => (showAuthorize(seleRows, callbackFn))
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "已经授权",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(Authorization, { isAuthorize: true }, {
              default: _withCtx(({ seleRows, callbackFn}) => [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (unauthorizeHandle(seleRows, callbackFn))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              column: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "被授权人员",
                  prop: "authUsers",
                  width: "120",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "订单开始日期",
                  prop: "orderStart",
                  width: "115",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "流水开始日期",
                  prop: "flowStart",
                  width: "115",
                  "show-overflow-tooltip": ""
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "授权",
      modelValue: isShowAuthorize.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isShowAuthorize).value = $event)),
      width: "770px",
      onClose: _cache[6] || (_cache[6] = ($event: any) => (authEle.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowAuthorize.value = false)),
          disabled: tabsLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(authSubmitHandle)())),
          loading: tabsLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "searchContent",
          model: _unref(authorizeObj),
          "label-width": "auto",
          inline: true,
          ref_key: "authEle",
          ref: authEle,
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "销售:",
              prop: "userId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(authorizeObj).userId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(authorizeObj).userId) = $event)),
                  class: "form-input",
                  placeholder: "请选择销售",
                  clearable: "",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userOptions), (user) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: user.name,
                        value: user.userId
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "订单开始日期:",
              prop: "orderStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(authorizeObj).orderStart,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authorizeObj).orderStart) = $event)),
                  type: "date",
                  clearable: "",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请选择订单开始日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "流水开始日期:",
              prop: "flowStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(authorizeObj).flowStart,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(authorizeObj).flowStart) = $event)),
                  type: "date",
                  clearable: "",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "请选择流水开始日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})